import { Injectable, OnDestroy } from '@angular/core';
import { map, Observable } from 'rxjs';
import { CodedValueItem } from 'app/shared/interfaces/coded-value-item.interface';
import {
  CacheFactoryService,
  ICacheService,
} from 'app/shared/services/cache-factory.service';
import { EsriUtils } from 'app/shared/utils/esri.utils';
import { FormatterUtils } from 'app/shared/utils/formatter.utils';

@Injectable()
export class SearchResultsInternalService implements OnDestroy {
  private cacheService: ICacheService;

  constructor(cacheFactory: CacheFactoryService) {
    this.cacheService = cacheFactory.getOrCreate('searchResultsInternal');
  }

  ngOnDestroy(): void {
    this.cacheService.dispose();
  }

  getDistinticValues(
    layer: __esri.FeatureLayer | __esri.Sublayer,
    fieldName: string,
    whereStr?: string
  ): Observable<CodedValueItem<any>[]> {
    whereStr = whereStr ?? '1=1';
    return this.cacheService.getCached({
      path: `${layer.url}@@${fieldName}@@where{${whereStr}}`,
      source: () => {
        const query = layer.createQuery();
        query.where = whereStr;
        query.outFields = [fieldName];
        query.orderByFields = [fieldName];
        query.returnDistinctValues = true;
        query.returnGeometry = false;

        return EsriUtils.queryFeatures(layer, query).pipe(
          map((res) => {
            const field = layer.fields.find((x) => x.name === fieldName);

            return res.features.map<CodedValueItem<any>>((feature) => {
              let value = feature.attributes[fieldName];
              let label: string;
              if (field?.domain) {
                label = EsriUtils.getFieldCodedDomainValue(
                  value,
                  (field.domain as __esri.CodedValueDomain).codedValues
                );
              } else if (field?.type === 'date') {
                if (value) {
                  value = new Date(value);
                }

                label = FormatterUtils.formatDateTime(value);
              } else {
                label = String(value);
              }

              return {
                label,
                value,
              };
            });
          })
        );
      },
    });
  }
}
